/**
 * THE BOARD'S ROOT RENDER — every prop read here, so every one is tracked.
 *
 * The props come as getters over reactive state. Handed to `h` as they are,
 * Vue reads them only while comparing old props to new, and it stops at the
 * first that differs: `unacknowledged` is a fresh object every render, so
 * nothing after it — the per-dish switch, the sold-out list — was ever a
 * dependency. The switch was pressed, the state moved, and the screen stayed
 * as it was. Spread here, each getter runs in the root's render.
 */

import { h, type Component } from "vue";
import StationBoard from "./ui/StationBoard.vue";

export const boardRoot = (props: () => object, board: Component = StationBoard) => ({
  render: () => h(board, { ...props() }),
});
